import React from 'react';
import Pagination from 'material-ui-pagination';
import styled from 'styled-components';

const PaginationContainer = styled.div`
  margin: 0;
`;

const defaultPagesDisplay = 10;

const StyledPagination = (props) => (
  <PaginationContainer {...props}>
    <Pagination display={defaultPagesDisplay} {...props} />
  </PaginationContainer>
);

export default StyledPagination;



// WEBPACK FOOTER //
// ./components/atoms/pagination/Pagination.js